import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

import { getUser } from './service/AuthService';
import './css/Daily.css';

// TODO: move URLs to environment variables when backend routes are finalized
const membershipUpdatePaymentUrl =
    'https://lkrse43p4g.execute-api.us-east-1.amazonaws.com/dev/membership/update-payment';
const membershipCancelUrl =
    'https://lkrse43p4g.execute-api.us-east-1.amazonaws.com/dev/membership/cancel';

const requestHeaders = {
    'x-api-key': 'mCQrNSvy7X5AUdJlF2ybc3LdEFGndN885kzttyvB'
};

const ManageMembership = () => {
    const navigate = useNavigate();
    const user = getUser();

    const [message, setMessage] = useState('');
    const [messageTone, setMessageTone] = useState('error');
    const [updatingPayment, setUpdatingPayment] = useState(false);
    const [cancelling, setCancelling] = useState(false);

    const postMembership = (url, onSuccessText) => {
        setMessage('');
        const requestConfig = {
            headers: requestHeaders
        };
        const requestBody = { user };

        return axios
            .post(url, requestBody, requestConfig)
            .then(() => {
                setMessageTone('success');
                setMessage(onSuccessText);
            })
            .catch((error) => {
                setMessageTone('error');
                if (error.response?.status === 401 || error.response?.status === 403) {
                    setMessage(error.response?.data?.message || 'You are not authorized to perform this action.');
                } else if (error.response?.data?.message) {
                    setMessage(error.response.data.message);
                } else {
                    setMessage('Something went wrong. Please try again later or contact support.');
                }
            });
    };

    const handleUpdatePayment = () => {
        if (updatingPayment || cancelling) return;
        setUpdatingPayment(true);
        postMembership(
            membershipUpdatePaymentUrl,
            'Payment update request received. Check your email if we sent a billing link.'
        ).finally(() => setUpdatingPayment(false));
    };

    const handleCancelSubscription = () => {
        if (updatingPayment || cancelling) return;
        const confirmed = window.confirm(
            'Cancel your subscription? You may keep access until the end of the current billing period. This cannot be undone from the app in some cases—confirm only if you intend to cancel.'
        );
        if (!confirmed) return;

        setCancelling(true);
        postMembership(
            membershipCancelUrl,
            'Cancellation request received. You will get a confirmation by email when processing is complete.'
        ).finally(() => setCancelling(false));
    };

    return (
        <div className="wrapper supportScreen">
            <div className="supportSurface">
                <div className="supportHeader">
                    <h2 className="dailyMainTitle">Subscription details</h2>
                    <p className="membershipStatusLine">You have Premium!</p>
                </div>

                <div className="supportSectionCard">
                    <h5 className="supportSectionTitle">Manage subscription</h5>
                    <p className="membershipPlanLabel">Your plan</p>
                    <p className="membershipPlanName">Monthly Premium</p>
                    <p className="membershipMeta">Next payment: June 30, 2026</p>
                    <p className="inDevelopmentCopy inDevelopmentCopy--card membershipHelpCopy">
                        To stop future renewals, use Cancel subscription below. If you update your card, billing may take a
                        few minutes to refresh.
                    </p>
                    <p className="inDevelopmentCopy inDevelopmentCopy--card membershipNoteCopy">
                        Please note: refunds, if any, are handled according to your plan terms and may require contacting
                        support.
                    </p>

                    {message ? (
                        <p
                            className={
                                messageTone === 'success'
                                    ? 'membershipMessage membershipMessage--success'
                                    : 'membershipMessage membershipMessage--error'
                            }
                            role={messageTone === 'success' ? 'status' : 'alert'}
                        >
                            {message}
                        </p>
                    ) : null}

                    <div className="homeBttnContainer membershipActions">
                        <button
                            type="button"
                            className="homeBttn membershipBttnPrimary"
                            disabled={updatingPayment || cancelling}
                            onClick={handleUpdatePayment}
                        >
                            {updatingPayment ? 'Sending…' : 'Update payment details'}
                        </button>
                        <button
                            type="button"
                            className="homeBttn membershipBttnCancel"
                            disabled={updatingPayment || cancelling}
                            onClick={handleCancelSubscription}
                        >
                            {cancelling ? 'Sending…' : 'Cancel subscription'}
                        </button>
                    </div>
                </div>

                <div className="homeBttnContainer supportActions">
                    <button type="button" className="homeBttn" onClick={() => navigate('/settings')}>
                        Back to Settings
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ManageMembership;
